<script>
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import axios from 'axios';
import { URLS } from '@/services/Constants';
import GroupService from '@/services/GroupService';
import VoicemailboxService from '@/services/VoicemailboxService';

export default {
    name: 'GroupTile',
    components: {
        ButtonIconLeft,
    },
    props: {
        groupId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            group: {},
            userCount: 0,
            phonenumber: {},
            voicemailboxNumber: ''
        };
    },
    created() {
        GroupService.getGroupById(this.groupId)
        .then((response) => {
            this.group = response.data;
            this.getGroupCount();
            this.getGroupPhonenumber();

            VoicemailboxService.getAllVoicemailboxes().then(responseGetAllVoicemailboxes => {
                if (responseGetAllVoicemailboxes.data && responseGetAllVoicemailboxes.data.length > 0) {
                    this.getVoicemailboxForGroup(responseGetAllVoicemailboxes.data);
                }
            });
        });
    },
    methods: {
        getGroupCount() {
            for (const entry of this.group.assignableUsers) {
                if (entry.assigned) {
                    this.userCount++;
                }
            }
        },
        getGroupPhonenumber() {
            for (const entry of this.group.assignableNumbers) {
                if (!entry.intern) {
                    if (entry.assigned) {
                        this.phonenumber = '+' + entry.countryCode + ' ' + entry.localAreaCode + ' '
                                            + entry.extension;
                    }
                }
            }
        },
        getVoicemailboxForGroup(voicemailboxes) {
            for (const voicemailbox of voicemailboxes) {
                if (voicemailbox.assignedgroups.length > 0 && voicemailbox.assignedgroups[0] === this.group.name) {
                    this.voicemailboxNumber = '*9' + voicemailbox.mailboxnumber;
                }
            }
        },
    },
};
</script>

<template>
<div class="group-tile">
    <div class="right">
        <ButtonIconLeft @onClick="$router.push('/groups/' + groupId)" buttonTitle="bearbeiten" src="edit" cssClass="btn btn-tertiary"/>
    </div>
    <div class="group-info">
        <div class="logo-and-group-name">
            <img src="@/assets/starface_icons_png/24/orange/teams_24@2x.png" alt="Mail Logo" width="40" height="34">
            <h2 class="group-name">{{group.name}}</h2>
        </div>
        <hr>
        <div class="phonenumber">{{phonenumber}}</div>
        <span class="voice-mailbox-number">Mailboxnummer: {{voicemailboxNumber}}</span>
    </div>
    <div class="user-counter">
        ({{userCount}} Mitglieder)
    </div>
</div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.group-tile {
    margin-top: 24px;
    padding: 16px;
    background-color: white;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    .right {
        display: grid;
        display: -ms-grid;
        grid-columns: 1fr;
        -ms-grid-columns: 1fr;
        .btn {
            justify-self: end;
            -ms-grid-column-align: end;
        }
    }
    .group-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-top: 18px;
        padding-bottom: 38px;
        hr {
            opacity: 0.5;
            width: 100%
        }
        .logo-and-group-name {
            display: flex;
            flex-direction: row;
            align-items: center;
            img {
                margin: 16px 16px 0 0;
            }
            .group-name {
                margin-top: 8px;
            }
        }
        .phonenumber {
            padding-bottom: 8px;
        }
        .voice-mailbox-number {
            font-size: 18px
        }
    }
    .user-counter {
        font-size: 16px;
    }
}
</style>
